import { render, staticRenderFns } from "./guishu-dia.vue?vue&type=template&id=c597795e&"
import script from "./guishu-dia.vue?vue&type=script&lang=js&"
export * from "./guishu-dia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports